import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import pegawaiShiftService from "../../services/pegawaiShiftService";
import Cookies from "js-cookie";
import sppdProyekService from "../../services/sppdProyekService";

export const initialState = {
    loading_pegawai_shift: false,
    data_pegawai_shift: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataPegawaiShift = createAsyncThunk('pegawai_shift/data',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiShiftService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('pegawai_shift/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiShiftService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('pegawai_shift/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiShiftService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('pegawai_shift/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pegawaiShiftService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})


export const pegawaiShiftSlice = createSlice({
    name: 'pegawai_shift',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_pegawai_shift = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPegawaiShift.fulfilled, (state, action) => {
                state.loading_pegawai_shift = false
                state.data_pegawai_shift = action.payload??[]
            })
            .addCase(getDataPegawaiShift.pending, (state) => {
                state.loading_pegawai_shift = true
            })
            .addCase(getDataPegawaiShift.rejected, (state, action) => {
                state.loading_pegawai_shift = false
                state.data_pegawai_shift = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_pegawai_shift = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_pegawai_shift = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_pegawai_shift = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = pegawaiShiftSlice.actions

export default pegawaiShiftSlice.reducer
